import { Nullable } from '@carvector/shared/util-type-fest';

export const againstNullOrUndefined = <T>(
  argument: Nullable<T>
): argument is NonNullable<T> =>
  argument === null || argument === undefined ? false : true;
